var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.plaintext)?_c('span',[_c('span',{staticClass:"checkboxGroup",domProps:{"innerHTML":_vm._s(_vm.displayText)}}),(_vm.displayText != '')?_vm._t("default"):_vm._e()],2):_c('b-form-checkbox-group',_vm._g(_vm._b({},'b-form-checkbox-group',_vm.props,false),_vm.listeners),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }